import Navbar from "Components/Navbar/Navbar";
function TermsOfService() {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1 py-16">
        <div className="container mx-auto px-4">
          <div className="mx-auto max-w-3xl prose prose-gray prose-invert">
            <h1 className="text-4xl font-bold tracking-tight mb-2">
              Terms of Service
            </h1>
            <p className="text-muted-foreground text-sm mb-8">
              Last updated: February 1, 2026
            </p>

            <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">
              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  1. Acceptance of Terms
                </h2>
                <p>
                  By accessing and using the ShoUp platform
                  (&quot;Service&quot;), you accept and agree to be bound by the
                  terms and provision of this agreement. If you do not agree to
                  abide by the above, please do not use this service.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  2. Description of Service
                </h2>
                <p>
                  ShoUp provides a self-service onboarding and management
                  platform for community heads and events organizers. The
                  Service includes tools for event management, membership
                  management, community building, payment processing, and
                  analytics.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  3. User Accounts
                </h2>
                <p>
                  To use certain features of the Service, you must register for
                  an account and provide accurate, current, and complete
                  information. You are responsible for maintaining the
                  confidentiality of your account credentials and for all
                  activities that occur under your account.
                </p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>
                    You must be at least 18 years old to create an account
                  </li>
                  <li>You may not create more than one personal account</li>
                  <li>You are responsible for all activity on your account</li>
                  <li>
                    You must notify us immediately of any unauthorized use
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  4. Application Process
                </h2>
                <p>
                  All new users must complete an application process. Approval
                  is at the sole discretion of ShoUp. We reserve the right to
                  reject or revoke access at any time for violations of these
                  terms or for any other reason.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  5. Payment Terms
                </h2>
                <p>
                  The Service integrates with Stripe for payment processing. By
                  using payment features, you also agree to Stripe&apos;s terms
                  of service. ShoUp charges a platform fee on transactions
                  processed through the Service. Payout schedules and fees are
                  detailed in your account settings.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  6. Content and Conduct
                </h2>
                <p>
                  You retain ownership of all content you upload to the Service.
                  By uploading content, you grant ShoUp a non-exclusive,
                  worldwide license to use, display, and distribute your content
                  in connection with the Service.
                </p>
                <p className="mt-2">You agree not to:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>
                    Upload content that is illegal, offensive, or violates
                    third-party rights
                  </li>
                  <li>Use the Service for fraudulent or deceptive purposes</li>
                  <li>Interfere with or disrupt the Service</li>
                  <li>
                    Attempt to gain unauthorized access to other users&apos;
                    accounts
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  7. Limitation of Liability
                </h2>
                <p>
                  ShoUp shall not be liable for any indirect, incidental,
                  special, consequential, or punitive damages resulting from
                  your use of or inability to use the Service. Our total
                  liability shall not exceed the amount you have paid to us in
                  the twelve months preceding the claim.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  8. Termination
                </h2>
                <p>
                  Either party may terminate this agreement at any time. Upon
                  termination, your right to use the Service will immediately
                  cease. You may export your data prior to account deletion.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  9. Changes to Terms
                </h2>
                <p>
                  We reserve the right to modify these terms at any time. We
                  will notify users of material changes via email or through the
                  Service. Continued use after changes constitutes acceptance of
                  the new terms.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">
                  10. Contact Information
                </h2>
                <p>
                  For questions about these Terms of Service, please contact us
                  at{" "}
                  <a
                    href="mailto:legal@shoup.co"
                    className="text-primary hover:underline"
                  >
                    legal@shoup.co
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
}
export { TermsOfService as default };
